/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/ListedAssetsTable/graphql/listed-asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {useAsset} from "../pages/ListedAssetsTable/provider";
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const MODULE_NAME = "ListedAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ListedAssetTableService {
    private static instance: ListedAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ListedAssetTableService {
        if (!ListedAssetTableService.instance) {
            ListedAssetTableService.instance = new ListedAssetTableService(props);
        }
        return ListedAssetTableService.instance;
    }



    async getListedAssetTable(limit: number, skip: number, filter: any) {
        const{ id}= useAsset();
        console.log("sanm",id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        assetTableCriteria: {
                            ...filter
                        },
                        store:id,
                        offset: skip,
                        size: limit,
                    },
                    fetchPolicy: "network-only",
                });
                if(res){
                    console.log("",res?.data?.getListedAssetTable)
                    let _found = {
                        currentPage:res?.data?.getListedAssetTable?.currentPage,
                        data:{
                            columnDefs:res?.data?.getListedAssetTable?.data?.columnDefs,
                            rowData:res?.data?.getListedAssetTable?.data?.rowData.map((item:any)=>{
                                return({
                                    ...item,
                                    storeId:id
                                })
                            })
                        },
                        pageSize:res?.data?.getListedAssetTable?.pageSize,
                        totalCount:res?.data?.getListedAssetTable?.totalCount,
                        totalPages:res?.data?.getListedAssetTable?.totalPages
                     
                    }
                    console.log("",_found)
                    if (_found) {
                        return _found;
                    }
                }
                log.success(MODULE_NAME, "getListedAssetTable: ", res?.data?.getListedAssetTable);
                // console.log("SAANJAY")
                // if(res?.data?.getListedAssetTable){

                //     return {
                //         tableData :res?.data?.getListedAssetTable,
                //         storeId:id,
                //     }
                // }
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }

    
}
